import { o_util } from "../chunks/common-namespaces-client-CHyZgmlk.mjs";
import { asExport } from "../chunks/common-core-client-BYCqsbss.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const cookie = /*           */ asExport(o_util, "cookie", {});
const exists = /*           */ asExport(cookie, "exists", noop);
const get = /*           */ asExport(cookie, "get", noop);
const remove = /*           */ asExport(cookie, "remove", noop);
const set = /*           */ asExport(cookie, "set", noop);
export {
  cookie,
  exists,
  get,
  remove,
  set
};
/*                                      */
